import styled from '@emotion/styled';
import { Divider as _Divider, Paper } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { SingleAssignmentFragment } from '../../../../graphql/generated/graphql_offer';
import _OfferListItemHeader from '../../../component/compound/OfferList/OfferListItemHeader';
import { SPACING_UNIT } from '../../../constant/spacing';
import _AssignedOfferDisplay from './AssignedOfferDisplay';

export interface Props {
  assignment: SingleAssignmentFragment;
  className?: string;
}

const AssignmentListItem = ({ assignment, className }: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      <OfferListItemHeader offer={assignment.offer} />
      <Divider />
      <AssignedOfferDisplay assignment={assignment} />
    </Root>
  );
};

const Root = styled(Paper)({});

const OfferListItemHeader = styled(_OfferListItemHeader)({
  padding: `${SPACING_UNIT}px ${SPACING_UNIT * 2}px`,
  backgroundColor: '#e2e6ef',
});

const Divider = styled(_Divider)({});

const AssignedOfferDisplay = styled(_AssignedOfferDisplay)({
  padding: `${SPACING_UNIT}px ${SPACING_UNIT * 2}px`,
});

export default AssignmentListItem;
